export default "__VITE_ASSET__aA91wdt$__"